import React from "react";
import { CiSearch } from "react-icons/ci";

const Search = ({
  placeHolder = "Search...",
  onSearch,
  idName,
  searchName,
  searchValue,
  extraClasses = "",
}) => {
  return (
    <div className={`relative w-full  ${extraClasses}`}>
      {/* Input */}
      <input
        type="text"
        id={idName}
        name={searchName}
        value={searchValue}
        onChange={(e) => {
          // remove leading spaces only
          const trimmedValue = e.target.value.replace(/^\s+/, "");
          onSearch(trimmedValue);
        }}
        placeholder={placeHolder}
        className="
    w-full
    rounded-lg
    border border-gray-200
    bg-white
    py-2.5
    pl-4
    pr-11
    text-sm sm:text-base
    text-gray-700
    placeholder-gray-400
    outline-none
    focus:border-[#FF6943]
    focus:ring-2
    focus:ring-[#FFCCBF]
    transition
  "
      />

      {/* Search Icon */}
      <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
        <CiSearch size={20} className="text-gray-400" />
      </span>
    </div>
  );
};

export default Search;
